var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.reports.length === 0)?_c('no-data'):_vm._l((_vm.reports.flat()),function(item){return _c('c-report-item',{key:item.key,attrs:{"data":item}})})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }